import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { saveUserData, updateUserData, getUserListById } from "../../redux/actions/UserActions";
import { getAllStateList, getAllCityStateWiseList, getMasterUsertypeList, getAllUsertypeUserList, getMasterUsertypeUserWiseList } from "../../redux/actions/MasterActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import HyperDatepicker from "../../Components/Datepicker";
import { getDateTimeMysqlGivenFormatYmd } from '../../util/generalUtills'
import Preloader from "../../Components/Preloader";

const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [stateId, setStateId] = useState(null);
    const [fieldErrors, setFieldErrors] = useState(null);

  const [typeId, setTypeId] = useState(null);
    const [roleCode,setroleCode]=useState("");
  
  const [showReporting, setShowReporting] = useState(false);
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    userReducer: {
      userLists,
      loadingUser,
      errorsUser,
      changedUserStatus,
    },
    masterReducer: {
      masterStateLists,
      masterCityStateWiseLists,
      masterUsertypeLists,
      masterUsertypeUserLists,
      loadingMaster,
      errorsMaster,
      masterUsertypeUserWiseLists
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getAllStateList(auth?.accessToken));
      dispatch(getMasterUsertypeList(auth?.accessToken));
  
    }
  }, [auth?.accessToken]);

  useEffect(() => {
    if (auth?.accessToken && stateId) {
      dispatch(getAllCityStateWiseList(auth?.accessToken, stateId));
    }
  }, [auth?.accessToken, stateId, dispatch]);

   useEffect(() => {
    console.log("kjhkjhj",formData?.roleId)
    if (auth?.accessToken && formData?.roleId) {
          dispatch(getMasterUsertypeUserWiseList(auth?.accessToken,formData?.roleId))
    }
  }, [auth?.accessToken, dispatch,formData?.roleId]);

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
      dispatch(updateUserData(auth?.accessToken, formData, id));
    }
    else {
      dispatch(saveUserData(auth?.accessToken, formData));
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(getUserListById(auth?.accessToken, id));
    }
  }, [auth?.accessToken, id]);

  useEffect(() => {
    if (id) {
      if (userLists && Object.keys(userLists).length > 0) {
        setFormData({
          stateCode: userLists?.state?.nicStateCode,
          cityCode: userLists?.city?.nicCityCode,
          roleId: userLists?.role?.roleCode,
          reportingId: userLists?.reportingUser?.name,
          name: userLists?.name,
          mobile: userLists?.mobile,
          email: userLists?.email,
          address: userLists?.address,
          username: userLists?.username,
          password: userLists?.password,
          threshold: userLists?.threshold,
          status:userLists?.status,
          isRegistrationCompleted:userLists?.isRegistrationCompleted,
        });
      }
    }

  }, [userLists])

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsUser && Object.keys(errorsUser).length > 0) {
      if (errorsUser?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsUser?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_USER_STATUS' });
      } else if (errorsUser?.status === 400) {
        // Handle other status
            if (errorsUser?.data?.errors && Array.isArray(errorsUser.data.errors)) {
          const transformedErrors = {};
          errorsUser.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      } else {
        dispatch({ type: 'RESET_DELETE_USER_STATUS' });
      }
    }
  }, [errorsUser, dispatch]);

  useEffect(() => {
    if (changedUserStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedUserStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_USER_STATUS' });
      navigate(-1);
    }
  }, [changedUserStatus, dispatch, navigate]);

  // Reset formData and errorsUser when the component mounts
  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_USER_STATUS' });
  }, [dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

    const inputHandlerpassword = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '') // Remove spaces 
    setFormData({ ...formData, [name]: processedValue });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };




  const selectHandler = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData[0].value,
    }));
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler2 = (selectedData, name) => {

    const selectedId = selectedData[0]?.state_code;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedId
    }));

  //   if (name === "user_type_id") {
  //     const type = selectedData[0].type;
  //     const reporting = selectedData[0].reportingId;
  //     if (type === "1") {
  //       dispatch(getAllUsertypeUserList(auth?.accessToken, reporting, formData.city_id));
  //       //setTypeId(selectedUserType?.reporting);
  //       setShowReporting(true);
  //     }
  //     else {
  //       setShowReporting(false);
  //     }
  //   }
  //    if (fieldErrors?.[name]) {
  //     setFieldErrors(prev => {
  //       const newErrors = { ...prev };
  //       delete newErrors[name];
  //       return newErrors;
  //     });
  //   }

  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsUser?.data?.username ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsUser?.data?.username? 'red' : base.borderColor,
      }
    }),
  };

  const onDateChange = (name, value) => {
    if (value) {
      setFormData({ ...formData, [name]: getDateTimeMysqlGivenFormatYmd(value) });
    }
  };
  useEffect(()=>{
    setFieldErrors({})

  },[navigate]);

    // useEffect(() => { 
    //   console.log('fieldErrors', fieldErrors);
    // },[fieldErrors]);


  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("User"), path: "Users" },
          { label: id ? t("Update User") : t("Add User"), path: "/Add-User", active: true },
        ]}
        title={id ? t("Update User") : t("Add User")}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              {errors?.data?.message && (
                <div className="alert alert-danger">
                  {errors.data.message}
                </div>
              )}
              <Row>
                <Col lg={4}>
                    <Form.Group className="mb-3">
                                      <Form.Label>{t("State")}</Form.Label>
                                      <Select
                                      className={fieldErrors?.stateCode ? "border-danger" : ""}
                                        options={masterStateLists}
                                        values={masterStateLists?.filter(state => state.stateCode === formData.stateCode)}
                                        name="stateId"
                                        labelField={"stateName"}
                                        valueField={"stateCode"}
                                        searchBy={"stateName"}
                                        onChange={(selectedData) => {
                                          setFormData(prevFormData => ({
                                            ...prevFormData,
                                              stateCode: selectedData[0]?.stateCode,
                                          }));
                                          dispatch(getAllStateList(auth?.accessToken, selectedData[0]?.stateCode));
                                          setStateId(selectedData[0]?.stateCode);
                                        }}
                                       
                                      />
                      
                  
                                      {fieldErrors?.stateCode && (
                                        <div className="invalid-feedback d-block">
                                          <p className="text-danger">{fieldErrors?.stateCode}</p>
                                        </div> 
                                       )} 
                                    </Form.Group>
                                  </Col>
                

                            <Col lg={4}>
                             <Form.Group className="mb-3">
                               <Form.Label>{t("City")}</Form.Label>
                               <Select
                               className={fieldErrors?.cityCode ? "border-danger" : ""}
           
                                 options={masterCityStateWiseLists}
                                 values={masterCityStateWiseLists?.filter(city => city.cityCode === formData.cityCode)}
                                 name="cityId"
                                 labelField={"cityName"}
                                 valueField={"cityCode"}
                                 searchBy={"cityName"}
                                 onChange={(selectedData) => {
                                   setFormData(prevFormData => ({
                                     ...prevFormData,
                                     cityCode: selectedData[0]?.cityCode,
                                   }));
                              
                                 }}
                             
                               />
           
                               {fieldErrors?.cityCode && (
                                 <div className="invalid-feedback d-block">
                                   <p className="text-danger">{fieldErrors?.cityCode}</p>
                                 </div>
                               )}
                             </Form.Group>
                           </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("User Type")}</Form.Label>
                    <Select
                       className={fieldErrors?.roleId? "border-danger" : ""}

                      options={masterUsertypeLists}
                      values={masterUsertypeLists?.filter(roles => roles?.roleCode === formData?.roleId)}
                      name="usertype"
                      labelField={"roleName"}
                      valueField={"roleCode"}
                      searchBy={"roleName"}
                      onChange={(selectedData) => {
                        //selectHandler2(selectedData[0]?.state_code, "state_id")
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          "roleId": selectedData[0]?.roleCode,
                        }));
                        if (selectedData[0]?.type === "1") {
                          dispatch(getAllUsertypeUserList(auth?.accessToken, selectedData[0]?.reportingId, formData.roleId));
                          //setTypeId(selectedUserType?.reporting);
                          setShowReporting(true);
                        }
                        else {
                          setShowReporting(true);
                        }
                      }
                      }
                      styles={customSelectStyles}
                    />

                    {fieldErrors?.roleId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.roleId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                {showReporting && (
                  <Col lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Reporting To")}</Form.Label>
                      <Select
                        options={masterUsertypeUserWiseLists}
                        values={masterUsertypeUserWiseLists?.filter(reportingId => reportingId.name === formData.reportingId)}
                        name="reportingId"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        onChange={(selectedData) => {
                          //selectHandler2(selectedData[0]?.state_code, "state_id")
                          setFormData(prevFormData => ({
                            ...prevFormData,
                            "reportingId": selectedData[0]?.id,
                          }));
                        }
                        }
                        styles={customSelectStyles}
                      />
                      {fieldErrors?.reportingId && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{fieldErrors?.reportingId}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}

                <Col lg={4}>
                  <FormInput
                    label={t("Name")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.name}
                    name="name"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Mobile Number")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.mobile}
                    name="mobile"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Email")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.email}
                    name="email"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Address")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.address}
                    name="address"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Threshold ")}
                    type="number"
                    min={0}
                    max={100}
                    errors={fieldErrors}
                    value={formData.threshold}
                    name="threshold"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                {(!id) && (
                  <>
                    <Col lg={4}>
                      <FormInput
                        label={t("Username")}
                        type="text"
                        errors={fieldErrors}
                        value={formData.username}
                        name="username"
                        onChange={inputHandlerCaps}
                        containerClass={"mb-3"}
                      />
                    </Col>
                  </>
                )}

                {(!id) && (
                  <>
                    <Col lg={4}>
                      <FormInput
                        label={t("Password")}
                        type="text"
                        errors={fieldErrors}
                        value={formData.password}
                        name="password"
                        onChange={inputHandlerpassword}
                        containerClass={"mb-3"}
                      />
                    </Col>
                  </>
                )}




              </Row>

              <div className="d-flex justify-content-center">
                {loadingUser ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loadingUser}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingMaster && (<Preloader />)}
      {loadingUser && (<Preloader />)}
    </>
  );
};

export default Dashboard;
